module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-pool@2x.png?19c80521fa1f4a4f895a1f40c343762a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-pool@2x.png
// module id = 1044
// module chunks = 1